"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOidcConfig = void 0;
const lodash_1 = require("lodash");
const defaultConfig = {};
function createOidcConfig(config) {
    return lodash_1.merge({}, defaultConfig, config);
}
exports.createOidcConfig = createOidcConfig;
//# sourceMappingURL=oidc-partial.js.map